//Handle post filtering - ajax

let postGridFilters;

const filterState = {
    categories: [],
    contentTypes: []
};

const saveStateToSessionStorage = () => {
    const state = {
        categories: filterState.categories,
        contentTypes: filterState.contentTypes,
        currentPage: document.querySelector('#posts-load-more')?.getAttribute('data-next') || 1
    };
    sessionStorage.setItem('postFiltersState', JSON.stringify(state));
};

const updateFilterState = () => {
    const categoryElements = document.querySelectorAll('[data-taxonomy="category"] input:checked');
    const contentTypeElements = document.querySelectorAll('[data-taxonomy="content-type"] input:checked');

    filterState.categories = categoryElements.length > 0 ? Array.from(categoryElements).map(input => input.value) : [];
    filterState.contentTypes = contentTypeElements.length > 0 ? Array.from(contentTypeElements).map(input => input.value) : [];

    // Save state to sessionStorage
    saveStateToSessionStorage();
};

const restoreStateFromSessionStorage = () => {
    const state = JSON.parse(sessionStorage.getItem('postFiltersState'));
    if (state) {
        filterState.categories = state.categories;
        filterState.contentTypes = state.contentTypes;
        applyStateToUI(state);
        const perPage = document.querySelector('#posts-load-more')?.getAttribute('data-per-page') || null;
        getPosts(filterState, perPage);
    }
};

const applyStateToUI = (state) => {
    document.querySelectorAll('[data-taxonomy="category"] input').forEach(input => {
        input.checked = state.categories.includes(input.value);
    });
    document.querySelectorAll('[data-taxonomy="content-type"] input').forEach(input => {
        input.checked = state.contentTypes.includes(input.value);
    });
    // Update the labels and active filters UI as needed
    document.querySelector('.post-grid-active-filters').innerHTML = '';
    document.querySelectorAll('.dropdown-option input:checked').forEach(input => {
        addFilterButton(input);
    });
};

const clearSessionStateOnInitialLoad = () => {
    if (performance.navigation.type !== performance.navigation.TYPE_BACK_FORWARD) {
        sessionStorage.removeItem('postFiltersState');
    }
};

const bindUIEvents = () => {
    const clearFilterButton = document.querySelector('.clear-filter-button');
    const applyFilterButton = document.querySelector('.filter-button');

    if (clearFilterButton) {
        clearFilterButton.addEventListener('click', () => {
            clearFilterButton.setAttribute('disabled', 'disabled');

            document.querySelectorAll('.checkbox-dropdown.on').forEach((el) => {
                el.classList.remove('on');
                el.querySelector('.dropdown-list').setAttribute('hidden', 'hidden');
            });

            document.querySelectorAll('.dropdown-option input').forEach((input) => {
                input.checked = false;
                input.dispatchEvent(new Event('change'));
            });

            updateFilterState();
            const perPage = document.querySelector('#posts-load-more')?.getAttribute('data-per-page');
            getPosts({}, perPage);
        });
    }

    if (applyFilterButton) {
        applyFilterButton.addEventListener('click', () => {
            applyFilterButton.setAttribute('disabled', 'disabled');

            document.querySelectorAll('.checkbox-dropdown.on').forEach((el) => {
                el.classList.remove('on');
                el.querySelector('.dropdown-list').setAttribute('hidden', 'hidden');
            });

            updateFilterState();
            const perPage = document.querySelector('#posts-load-more')?.getAttribute('data-per-page');
            getPosts(filterState, perPage);
        });
    }
}

const getPosts = (taxonomies, perPage = null) => {
    let queryStringArgs = {};

    if (taxonomies) {
        queryStringArgs = {...taxonomies};
    }

    if (perPage) {
        queryStringArgs['perPage'] = perPage;
    }

    const query = `${wpApiSettings.root}wp/v2/posts-tax?` + new URLSearchParams(queryStringArgs).toString();

    document.querySelector('.post-grid-filters').classList.add('active');

    jQuery.ajax({
        url: query,
        method: 'GET',
    })
        .done(handleUpdatePosts)
        .fail(handleUpdatePostsError)
        .always(handleUpdatePostsComplete);
}

const handleUpdatePosts = (res) => {
    document.getElementById('posts-grid').innerHTML = res.html;

    const event = new CustomEvent('postfilters.taxonomy.updated');
    document.dispatchEvent(event);
}

const handleUpdatePostsError = (res) => {
    // handle error
}

const handleUpdatePostsComplete = (res) => {
    //document.querySelector('#posts-load-more').classList.add('hidden');
    document.querySelector('.clear-filter-button').removeAttribute('disabled');
    document.querySelector('.filter-button').removeAttribute('disabled');
    document.querySelector('.post-grid-filters').classList.remove('active');
    document.querySelector('#posts-load-more').disabled = !res.more_posts
}

const addFilterButton = (checkbox) => {
    let taxonomy = checkbox.parentNode.dataset.taxonomy;
    let id = checkbox.value;
    let filterLabel = checkbox.parentNode.textContent.trim();

    let buttonElement = document.createElement('button');
    buttonElement.className = "post-grid-active-filter";
    buttonElement.dataset.taxonomy = taxonomy;
    buttonElement.dataset.id = id;

    buttonElement.innerHTML = `<span class="filter-name">${filterLabel}</span>
        <span class="icon"></span>`

    document.querySelector('.post-grid-active-filters').appendChild(buttonElement);

    // Add event listener to remove button on click & uncheck the associated checkbox
    buttonElement.addEventListener('click', function () {
        checkbox.checked = false;
        buttonElement.remove();

        var event = new Event('change');
        checkbox.dispatchEvent(event);

        // Trigger search update when a filter is removed
        updateFilterState();
        const perPage = document.querySelector('#posts-load-more')?.getAttribute('data-per-page');
        getPosts(filterState, perPage);
    });
}

const postFilters = () => {
    postGridFilters = document.querySelector('.post-grid-filters');

    if (!postGridFilters) {
        return;
    }

    bindUIEvents();
    // Clear session storage state on initial load
    clearSessionStateOnInitialLoad();
}

window.addEventListener('pageshow', (event) => {
    if (event.persisted || performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD) {
        restoreStateFromSessionStorage();
    }
});

export { filterState, postFilters, updateFilterState, getPosts };
